import React from "react"
import {Helmet} from "react-helmet"

type MetaProp = {
  name: string
  content: string
}

type MetaProps = {
  children: React.ReactNode
  title: string
  meta?: MetaProp[]
  bodyClass?: string
}

export function Meta({
  title,
  children,
  meta = [
    {
      name: "viewport",
      content: "width=device-width",
    },
  ],
  bodyClass,
}: MetaProps) {
  return (
    <>
      <Helmet meta={meta}>
        <link rel="icon" href="/favicon.svg" />
        <title>{title}</title>
        {bodyClass ? <body className={bodyClass}></body> : null}
      </Helmet>
      {children}
    </>
  )
}
